module.exports = "/_next/static/images/Coins@3x-995a7e41ecf470b4e11c9cdc5a9b7ee7.png";